function UserRoleValueType() {
    "use strict";
    //User Role Id
    this.Id = -1;

    this.UpdateUTC = new Date();
    // UserRole Name
    this.Description = null;
}
if (typeof exports !== 'undefined') {
    module.exports = UserRoleValueType;
}